import script from "./ClassicConference.vue?vue&type=script&setup=true&lang=js"
export * from "./ClassicConference.vue?vue&type=script&setup=true&lang=js"

import "./ClassicConference.vue?vue&type=style&index=0&id=27310ec6&lang=css"

const __exports__ = script;

export default __exports__